<template>
  <div class="detail-header-container">
    <div class="detail-header">
      <div class="item">
        <!-- 转库单号： -->
        <div class="row">
          <div class="label">{{ $t('message.transferOrderNumber') }}：</div>
          <div class="value">{{ detail.move_sn || '-' }}</div>
        </div>
        <!-- 客户ID -->
        <div class="row">
          <div class="label">{{ $t('message.clientID') }}：</div>
          <div class="value">{{ detail.user?.id || '-' }}</div>
        </div>
        <!-- 客户名 -->
        <div class="row">
          <div class="label">{{ $t('message.customerName') }}：</div>
          <div class="value">{{ detail.user?.realname || '-' }}</div>
        </div>
      </div>
      <div class="item">
        <!-- 装箱操作人： -->
        <div class="row">
          <div class="label">{{ $t('message.packBy') }}：</div>
          <div class="value">{{ detail.pack_by_admin?.realname || '-' }}</div>
        </div>
        <!-- 操作商品番数： -->
        <div class="row">
          <div class="label">{{ $t('message.operationProductSerialNumber') }}：</div>
          <div class="value">{{ detail.total_count || '-' }}</div>
        </div>
        <!-- 操作商品数量： -->
        <div class="row">
          <div class="label">{{ $t('message.operationProductQuantity') }}：</div>
          <div class="value">{{ detail.total_num || '-' }}</div>
        </div>
      </div>
      <div class="item">
        <!-- 业务员： -->
        <div class="row">
          <div class="label">{{ $t('message.salesman') }}：</div>
          <div class="value">{{ detail.user?.y_admin?.realname || '-' }}</div>
        </div>
        <!-- 采购员： -->
        <div class="row">
          <div class="label">{{ $t('message.buyer') }}：</div>
          <div class="value">{{ detail.user?.g_admin?.realname || '-' }}</div>
        </div>
        <!-- 配货员： -->
        <div class="row">
          <div class="label">{{ $t('message.distributionMember') }}：</div>
          <div class="value">{{ detail.user?.p_admin?.realname || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      detail: state => state.transferOrderDetail.detail || {
        user: {},
        pack_by_admin: {},
      },
    }),
  },
}
</script>
<style scoped lang="scss">
.detail-header-container {
  min-width: 1910px;
}

.detail-header {
  padding: 24px;
  background-color: #32323C;
  color: #fff;
  display: flex;



  .item {
    padding: 0 80px;
    border-right: 1px solid #545467;

    &:last-child {
      border-right: none;
    }

    &:first-child {
      padding-left: 0;
    }

    .row {
      margin-bottom: 12px;
      display: flex;
      line-height: 22px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        width: 100px;

      }

      .value {
        flex: 1;
      }
    }
  }
}
</style>
